export * from "-!../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Menu.vue?vue&type=template&id=5345b6a0&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/components/side-bar/Menu.vue?vue&type=template&id=5345b6a0&scoped=true&
// module id = 905
// module chunks = 0